export default defineNuxtPlugin((nuxtApp) => {
  // Catch Vue runtime errors
  if (nuxtApp.vueApp && nuxtApp.vueApp.config) {
    nuxtApp.vueApp.config.errorHandler = (err: unknown) => {
      try {
        // Log with identifiable prefix so we can grep in Vercel logs
        console.error("[global-client-error]", err);
      } catch (e) {
        console.error("[global-client-error] failed to log error", e);
      }
      // Do not rethrow — prevent crash during mount/hydration
    };
  }

  // Fallback global handlers early on
  if (process.client) {
    window.addEventListener("error", (ev) => {
      console.error("[window-error]", ev.error || ev.message, ev);
      ev.preventDefault && ev.preventDefault();
    });
    window.addEventListener("unhandledrejection", (ev) => {
      console.error("[unhandledrejection]", ev.reason, ev);
      ev.preventDefault && ev.preventDefault();
    });
  }
});
